
export default function(initialState:Object){
    
    return function(state = initialState, action){

        switch(action.type){

            case "SET_ERRORS":
                return action.errors

            case "CLEAR_ERRORS":
                return {}

            default: return state;

        }

    }

}




// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/modules/errors/errors-reducer.ts